import { render, staticRenderFns } from "./MobEsgReport.vue?vue&type=template&id=4a28ace9&scoped=true"
import script from "./MobEsgReport.vue?vue&type=script&setup=true&lang=js"
export * from "./MobEsgReport.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MobEsgReport.vue?vue&type=style&index=0&id=4a28ace9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a28ace9",
  null
  
)

export default component.exports